import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  IconButton,
  Container,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LogoIcon from "../../../assets/images/logo-icon.png";
import variables from "../../../assets/styles/variables.module.scss";
import TypingIndicator from "../../../Shared-ui/SharedComponents/TypingIndicator";
import LineMdAccount from "../../../assets/icons/LineMdAccount";
import { Params, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { Agent, AgentMetaData, AgentTheme } from "../../../Shared-ui/Types/Agent";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { AGENT, AGENT_SHORTCUT } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import PlayGroundInitialMessage from "../../Components/PlayGroundIntialMessage";
import { Message, UserMessage } from "../../../Shared-ui/Types/PlayGround";
import { v4 as uuidv4 } from "uuid";
import { PlayGroundEnum } from "../../../Shared-ui/Enum/PlayGroundEnum";
import { GetSession } from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { marked } from "marked";
import AgentPlayGroundTools from "../../Components/AgentPlayGroundTools";
import AgentPlaygroundReferences from "../../Components/AgentPlaygroundReferences";
import CachedIcon from "@mui/icons-material/Cached";
import AgentQuestions from "../../Components/AgentQuestions";
import AgentPrompts from "../../Components/AgentPromts";
import striptags from "striptags";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ChatInterfaceSettings from "../../Components/ChatInterfaceSettings";
import ChatIcon from "../../../assets/images/AgentStar.svg";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import NewChatIcon from "../../../assets/icons/NewChatIcon";
import EndChatIcon from "../../../assets/icons/EndChatIcon";
import RecentChatIcon from "../../../assets/icons/RecentChatIcon";
// import RecentChats from "../../Components/RecentChats";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PlotlyChart from "../../Components/PlotlyChart";
import { capitalizeFirstLetter } from "../../../Shared-ui/utils/Common/Common";
import { CircularProgress } from "@mui/material";
import VoiceRecorder from "../../../Shared-ui/SharedComponents/VoiceRecorder";
import { audioBlobToBase64 } from "../../../utils/audioUtils";
import { decodeHTMLEntities } from "../../../Shared-ui/utils/Common/Common";

import ContactForm from "../../Components/ContactForm/ContactForm";
import RecentChatsByUser from "../../Components/RecentsChatsByUser";


type ChatHistoryItem = {
  id: string;
  user_id: string;
  agent_id: string;
  agent_name: string;
  conversation_id: string;
  message_count: number;
  first_message_preview: string;
  last_message_preview: string;
  created_at: string;
  organization_id: string | null;
};


const AgentPlayground: React.FC = () => {
  const { agentId } = useParams<Params>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const uniqueId = uuidv4();
  const [intialMessage, setIntialMessage] = useState<string>("");
  const [agents, setAgents] = useState<Agent>();
  const [userInput, setUserInput] = useState<string>("");
  const [botTyping, setBotTyping] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [agentShortuts, setAgentShortuts] = useState<any>([]);
  const endOfMessagesRef = useRef<HTMLDivElement>(null);
  const [conversationId, setConversationId] = useState<string>("");
  const [showQuestions, setShowQuestions] = useState<boolean>(true);
  const [showInitialMessage, setShowInitialMessage] = useState(true);
  const [chatIcon, setChatIcon] = useState<string | null>(null);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [bubbleColor, setBubbleColor] = useState(variables.primaryColor);
  const [incomingTextColor, setIncomingTextColor] = useState("#000000");
  const [outgoingTextColor, setOutgoingTextColor] = useState("#000000");
  const [titleColor, setTitleColor] = useState("#000000");
  const [chatWindowColor, setChatWindowColor] = useState("#ffffff");
  const [chartVisibilityByMessage, setChartVisibilityByMessage] = useState<Record<number, boolean>>({});
  const [chartLoadingByMessage, setChartLoadingByMessage] = useState<Record<number, boolean>>({});
  const [isAgentChartable, setIsAgentChartable] = useState<boolean>(false);
  const [showCitations, setShowCitations] = useState<boolean>(false);
  const isCancelledStream = useRef<boolean>(true);
  const [currentAudioUrl, setCurrentAudioUrl] = useState<string | null>(null);
  const [agentTheme, setAgentTheme] = useState<AgentTheme>({

    backgroundColor: "#ffffff",
    titleColor: "#000000",
    outgoingChatTextColor: "#000000",
    incomingChatTextColor: "#000000",
    chatBubbleButtonColor: variables.primaryColor,
    mode: "single",
    angle: 180
  });
  const responseId = useRef<string>(uuidv4());
  const [showContactFormForMessageIndex, setShowContactFormForMessageIndex] = useState<number | null>(null);
  const [historyData, setHistoryData] = useState<{
    items: ChatHistoryItem[];
    pagination: { total: number; page: number; perPage: number };
  }>({
    items: [],
    pagination: { total: 0, page: 1, perPage: 10 },
  });




  // Helpers declared before use
  const hasChartDataApi = async (content: string) => {
    // Prefer server-provided chartability flag when available
    if (isAgentChartable) return true;

    // const text = (content || "").toLowerCase();
    // // Quick heuristics: numbers or common chart-like markers/keywords
    // const hasNumber = /\d/.test(text);
    // const keywords = [
    //   "table",
    //   "|",
    //   ",",
    //   ":",
    //   " - ",
    //   "%",
    //   "$",
    //   " vs ",
    //   "most",
    //   "top",
    //   "rank",
    //   "ranking",
    //   "leaders",
    //   "leaderboard",
    //   "highest",
    //   "lowest",
    //   "record",
    //   "records",
    //   "best",
    //   "worst",
    //   "runs",
    //   "goals",
    //   "points",
    // ];
    // const hasKeyword = keywords.some((k) => text.includes(k));
    // return hasNumber || hasKeyword;
  };

  const checkAndShowForm = async (messageContent: string, messageIndex: number) => {
    if (!messageContent) return;
    console.log(`[checkAndShowForm] Checking form for message index: ${messageIndex}`);
    console.log(`[checkAndShowForm] Message content (start): "${messageContent.substring(0, 100)}..."`);
    try {
      const response = await BaseInstance.post('/conversations/check-form', {
        message: messageContent,
        agent_id: agentId,
      });
      console.log('[checkAndShowForm] Backend response:', response.data);
      if (response.data?.requires_form) {
        console.log(`[checkAndShowForm] SUCCESS: Form required. Setting state to show form for index: ${messageIndex}`);
        setShowContactFormForMessageIndex(messageIndex);
      } else {
        console.log('[checkAndShowForm] INFO: Form not required by backend.');
      }
    } catch (error) {
      console.error("Failed to check for form requirement:", error);
    }
  };

  const tryParseChartFromRaw = (raw: string): any | null => {
    try {
      let text = (raw || "").trim();
      if (text.startsWith("```") && text.endsWith("```")) {
        text = text.replace(/^```[a-zA-Z0-9]*\s*/, "").replace(/\s*```$/, "").trim();
      }
      const obj = JSON.parse(text);
      if (obj && typeof obj === "object") {
        const pick = (o: any) => (o && typeof o === "object" ? o : null);
        const candidate = pick((obj as any).chartData) || obj;
        if (Array.isArray((candidate as any).data)) return candidate;
      }
    } catch { }
    return null;
  };

  useEffect(() => {
    const scrollBehavior = botTyping ? "auto" : "smooth";
    endOfMessagesRef.current?.scrollIntoView({ behavior: scrollBehavior });
  }, [messages.length, botTyping]);

  useEffect(() => {
    getAgent();
    getAgentShortCut();
  }, [agentId]);



  useEffect(() => {
    if (!botTyping) {
      inputRef.current?.focus();
    }
  }, [messages, botTyping]);

  const getAgent = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${AGENT}/${agentId}`).then(
        (res) => res?.data
      );
      // setIntialMessage(`Hello. I am ${data.name}! How can I assist you today?`);
      setIntialMessage(`Hello! How can I assist you today?`);
      setAgents(data);
      setAgentTheme(data.agent_metadata?.agent_theme || agentTheme);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getAgentShortCut = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${AGENT_SHORTCUT}`).then(
        (res) => res?.data
      );

      setAgentShortuts(data || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };
  const sendMessageQuestions = async (question: string) => {
    isCancelledStream.current = false;
    setShowInitialMessage(false);
    setShowQuestions(false);
    const data: UserMessage = {
      input: question,
      conversation_id: conversationId ? conversationId : "",
    };
    const userInputText = question; // Capture user input for form checking

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.agent_metadata.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  // const conId = parsed.conversation_id
                  tool_calls = parsed.metadata.tool_calls || [];
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    const nextAgentData: any = {
                      ...(lastMsg as any).agentData,
                      response: sanitizedContent,
                      conversation_id: parsed.conversation_id,
                      rawResponse: content,
                      metadata: {
                        tool_calls: tool_calls,
                        extra_data: { references: references },
                      },
                    };
                    lastMsg = {
                      ...lastMsg,
                      agentData: nextAgentData,
                    } as any;
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  if (parsed.metadata?.extra_data?.references) {
                    references = parsed.metadata.extra_data.references;
                  }
                  // Save chartability flag from final streamed chunk
                  if (typeof parsed.is_chartable !== "undefined") {
                    setIsAgentChartable(!!parsed.is_chartable);
                  }
                  // Handle chart data if present
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        const nextAgentData: any = {
                          ...(lastMsg as any).agentData,
                          response: "",
                          rawResponse: parsed.response,
                          chartData: chartData,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        };
                        lastMsg = { ...lastMsg, agentData: nextAgentData } as any;
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  } else {
                    // No explicit chart flag: check using API
                    const hasChart = await hasChartDataApi(content);
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      const maybeChart = hasChart ? tryParseChartFromRaw(content) : null;
                      const nextAgentData: any = {
                        ...(lastMsg as any).agentData,
                        rawResponse: content,
                        metadata: {
                          tool_calls: tool_calls,
                          extra_data: { references: references },
                        },
                      };
                      if (maybeChart) {
                        nextAgentData.chartData = maybeChart;
                        nextAgentData.response = "";
                      } else {
                        nextAgentData.hasChart = hasChart;
                        nextAgentData.response = (lastMsg as any).agentData?.response || "";
                      }
                      lastMsg = { ...lastMsg, agentData: nextAgentData } as any;
                      // Get the user's message (second to last message before this AI response)
                      const userMsg = preVal[preVal.length - 2];
                      const userInput = userMsg?.userData?.input || userInputText;
                      checkAndShowForm(userInput, preVal.length - 1);
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        const conId = responseData.conversation_id
        setConversationId(responseData.conversation_id);
        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;
        console.log(responseData);

        // Handle chart data if present
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    conversationId: conId,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        } else {
          setMessages((preVal) => {
            return [
              ...preVal,
              {
                sender: PlayGroundEnum.AGENT,
                agentData: {
                  response: rawHtml,
                  metadata: { tool_calls: tool_calls, extra_data: extra_data },
                },
              },
            ];
          });
          checkAndShowForm(userInputText, messages.length);
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessageShortcuts = async (shortcut: string, messageId: number) => {
    if (shortcut === "chart_format") {
      const msg = messages[messageId];

      const hasChartable =
        msg?.agentData?.isChartable || !!msg?.agentData?.chartData;

      if (!hasChartable) {
        dispatch(ShowError("Chart format cannot be generated for this response."));
        return;
      }
    }
    isCancelledStream.current = false;
    setShowQuestions(false);
    const message = messages[messageId];
    const plainText = striptags(message.agentData?.response || "");
    const data: UserMessage = {
      action: shortcut,
      original_content: plainText,
      conversation_id: conversationId ? conversationId : "",
    };

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: { ...data, input: `<i>${capitalizeFirstLetter(shortcut)}</i>` } },
    ]);
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.agent_metadata.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/post-response-shortcut?stream=true`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  // const conId = parsed.conversation_id
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    const nextAgentData: any = {
                      ...(lastMsg as any).agentData,
                      response: sanitizedContent,
                      conversation_id: parsed.conversation_id,
                      rawResponse: content,
                      metadata: {
                        tool_calls: tool_calls,
                        extra_data: { references: references },
                      },
                    };
                    lastMsg = {
                      ...lastMsg,
                      agentData: nextAgentData,
                    } as any;
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  if (parsed.metadata?.extra_data?.references) {
                    references = parsed.metadata.extra_data.references;
                  }

                  if (parsed.metadata?.tool_calls) {
                    tool_calls = parsed.metadata.tool_calls || [];
                  }

                  // Save chartability flag from final streamed chunk
                  if (typeof parsed.is_chartable !== "undefined") {
                    setIsAgentChartable(!!parsed.is_chartable);
                  }

                  // Handle chart data if present
                  if (parsed.is_chart && parsed.response) {
                    try {
                      const chartData = JSON.parse(parsed.response);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        const nextAgentData: any = {
                          ...(lastMsg as any).agentData,
                          response: "",
                          rawResponse: parsed.response,
                          chartData: chartData,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        };
                        lastMsg = { ...lastMsg, agentData: nextAgentData } as any;
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    } catch (chartError) {
                      console.error("Failed to parse chart data:", chartError);
                    }
                  } else {
                    // No explicit chart flag: check using API
                    const hasChart = await hasChartDataApi(content);
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      const maybeChart = hasChart ? tryParseChartFromRaw(content) : null;
                      const nextAgentData: any = {
                        ...(lastMsg as any).agentData,
                        rawResponse: content,
                        metadata: {
                          tool_calls: tool_calls,
                          extra_data: { references: references },
                        },
                      };
                      if (maybeChart) {
                        nextAgentData.chartData = maybeChart;
                        nextAgentData.response = "";
                      } else {
                        nextAgentData.hasChart = hasChart;
                        nextAgentData.response = (lastMsg as any).agentData?.response || "";
                      }
                      lastMsg = { ...lastMsg, agentData: nextAgentData } as any;
                      // Get the user's message (second to last message before this AI response)
                      const userMsg = preVal[preVal.length - 2];
                      const userInput = userMsg?.userData?.input || "";
                      checkAndShowForm(userInput, preVal.length - 1);
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });
                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/post-response-shortcut?stream=false`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        setConversationId(responseData.conversation_id);
        // const conId = responseData.conversation_id
        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;
        console.log(responseData);

        // Handle chart data if present
        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    conversation_id: responseData.conversation_id,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        } else {
          setMessages((preVal) => {
            return [
              ...preVal,
              {
                sender: PlayGroundEnum.AGENT,
                agentData: {
                  response: rawHtml,
                  metadata: { tool_calls: tool_calls, extra_data: extra_data },
                },
              },
            ];
          });
          // For shortcuts, get the original user message that triggered the AI response
          const originalUserMsg = messages[messageId - 1];
          const userInput = originalUserMsg?.userData?.input || "";
          if (userInput) {
            checkAndShowForm(userInput, messages.length);
          }
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
  };

  const sendVoiceMessage = async (audioBlob: Blob) => {
    isCancelledStream.current = false;
    setShowInitialMessage(false);
    setShowQuestions(false);
    setBotTyping(true);

    try {
      // Convert audio blob to base64 using chunked approach to avoid stack overflow
      const base64Audio = await audioBlobToBase64(audioBlob);

      const requestPayload = {
        audio_data: base64Audio,
        conversation_id: conversationId ? conversationId : "",
      };

      console.log('🎤 Sending voice message with payload:', requestPayload);

      const response = await fetch(
        `${AGENT}/${agentId}/voice`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${GetSession()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestPayload),
          mode: "cors",
          credentials: "same-origin",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to process voice message");
      }

      const result = await response.json();

      // Add user message (showing transcribed text)
      const userMessage: Message = {
        sender: PlayGroundEnum.USER,
        userData: {
          input: result.metadata?.transcribed_text || "Voice message",
          conversation_id: result.conversation_id || conversationId,
        },
      };

      // Add agent response with audio
      const agentMessage: Message = {
        sender: PlayGroundEnum.AGENT,
        agentData: {
          response: await marked.parse(result.response),
          conversation_id: result.conversation_id || conversationId,
          metadata: result.metadata,
          audioResponse: result.audio_response,
        },
      };

      setMessages((prev) => [...prev, userMessage, agentMessage]);
      setConversationId(result.conversation_id || conversationId);

      // Create audio URL for playback
      if (result.audio_response) {
        const audioFormat = result.metadata?.audio_format || 'mp3';
        const audioBlob = new Blob([Uint8Array.from(atob(result.audio_response), c => c.charCodeAt(0))], { type: `audio/${audioFormat}` });
        const audioUrl = URL.createObjectURL(audioBlob);
        setCurrentAudioUrl(audioUrl);

        // Auto-play the audio response
        const audio = new Audio(audioUrl);
        audio.play().catch(error => {
          console.log('Auto-play prevented:', error);
        });
      }

    } catch (error) {
      console.error('Voice message failed:', error);
      dispatch(ShowError('Failed to process voice message'));
    } finally {
      setBotTyping(false);
    }
  };

  const sendMessage = async () => {
    isCancelledStream.current = false;
    if (!userInput.trim()) return; // Hide Welcome messages
    setShowInitialMessage(false); // Hide Welcome messages
    setShowQuestions(false);
    const data: UserMessage = {
      input: userInput,
      conversation_id: conversationId ? conversationId : "",
    };

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: PlayGroundEnum.USER, userData: data, },
    ]);
    const userInputText = data.input; // Capture user input for form checking
    setUserInput("");
    setBotTyping(true);
    try {
      if (agents?.agent_metadata.streaming) {
        const response = await fetch(
          `${AGENT}/${agentId}/execute?stream=true`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!response.ok || !response.body) {
          throw new Error("Failed to stream");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // Add placeholder agent message
        setMessages((prev) => [...prev, { sender: PlayGroundEnum.AGENT, isMessageLike: null }]);

        let buffer = "";
        var content = "";
        var tool_calls: any[] = [];
        var references: any[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (isCancelledStream.current) break;

          buffer += decoder.decode(value, { stream: true });

          const lines = buffer.split("\n");
          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const jsonPart = line.replace(/^data: /, "").trim();

              if (jsonPart === "[DONE]") return;

              try {
                const parsed = JSON.parse(jsonPart);
                responseId.current = parsed.response_id
                if (!parsed.is_complete) {
                  content += parsed.response; // Assign directly here
                  setConversationId(parsed.conversation_id);
                  // const conId = parsed.conversation_id
                  const sanitizedContent = await marked.parse(content);
                  setMessages((preVal) => {
                    let lastMsg = preVal[preVal.length - 1];
                    const nextAgentData: any = {
                      ...(lastMsg as any).agentData,
                      response: sanitizedContent,
                      conversation_id: parsed.conversation_id,
                      rawResponse: content,
                      metadata: {
                        tool_calls: tool_calls,
                        extra_data: { references: references },
                      },
                    };
                    lastMsg = {
                      ...lastMsg,
                      agentData: nextAgentData,

                    } as any;
                    return [...preVal.slice(0, preVal.length - 1), lastMsg];
                  });
                } else {
                  if (parsed?.is_invalid_api_key) {
                    dispatch(ShowError(parsed?.error))
                  } else {
                    setMessages((preVal) => {
                      let lastMsg = preVal[preVal.length - 1];
                      const nextAgentData: any = {
                        ...(lastMsg as any).agentData,
                        isChartable: parsed.is_chartable,
                      };
                      lastMsg = {
                        ...lastMsg,
                        agentData: nextAgentData,
                      } as any;
                      return [...preVal.slice(0, preVal.length - 1), lastMsg];
                    });

                    if (parsed.metadata?.extra_data?.references) {
                      references = parsed.metadata.extra_data.references;
                    }

                    if (parsed.metadata?.tool_calls) {
                      tool_calls = parsed.metadata.tool_calls || [];
                    }

                    // Save chartability flag from final streamed chunk
                    if (typeof parsed.is_chartable !== "undefined") {
                      setIsAgentChartable(!!parsed.is_chartable);
                    }

                    // Handle chart data if present
                    if (parsed.is_chart && parsed.response) {
                      try {
                        const chartData = JSON.parse(parsed.response);
                        setMessages((preVal) => {
                          let lastMsg = preVal[preVal.length - 1];
                          const nextAgentData: any = {
                            ...(lastMsg as any).agentData,
                            response: "",
                            rawResponse: parsed.response,
                            chartData: chartData,
                            metadata: {
                              tool_calls: tool_calls,
                              extra_data: { references: references },
                            },
                          };
                          lastMsg = { ...lastMsg, agentData: nextAgentData, } as any;
                          return [...preVal.slice(0, preVal.length - 1), lastMsg];
                        });
                      } catch (chartError) {
                        console.error("Failed to parse chart data:", chartError);
                      }
                    } else {
                      // No explicit chart flag: check using API
                      const hasChart = await hasChartDataApi(content);
                      setMessages((preVal) => {
                        let lastMsg = preVal[preVal.length - 1];
                        const maybeChart = hasChart ? tryParseChartFromRaw(content) : null;
                        const nextAgentData: any = {
                          ...(lastMsg as any).agentData,
                          rawResponse: content,
                          metadata: {
                            tool_calls: tool_calls,
                            extra_data: { references: references },
                          },
                        };
                        if (maybeChart) {
                          nextAgentData.chartData = maybeChart;
                          nextAgentData.response = "";
                        } else {
                          nextAgentData.hasChart = hasChart;
                          nextAgentData.response = (lastMsg as any).agentData?.response || "";
                        }
                        lastMsg = { ...lastMsg, agentData: nextAgentData } as any;
                        // Get the user's message (second to last message before this AI response)
                        const userMsg = preVal[preVal.length - 2];
                        const userInput = userMsg?.userData?.input || userInputText || "";
                        if (userInput) {
                          checkAndShowForm(userInput, preVal.length - 1);
                        }
                        return [...preVal.slice(0, preVal.length - 1), lastMsg];
                      });
                    }

                  }
                }
              } catch (e) {
                console.error("Parse error:", jsonPart, e);
              }
            }
          }

          // Keep partial buffer (in case a line is split across chunks)
          buffer = lines[lines.length - 1];
        }
      } else {
        // streming is false

        const resData: any = await fetch(
          `${AGENT}/${agentId}/execute?stream=false`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${GetSession()}`,
              "Content-Type": "application/json",
              Accept: "text/event-stream",
            },
            body: JSON.stringify(data),
            mode: "cors",
            credentials: "same-origin",
          }
        );

        if (!resData.ok) {
          throw new Error("Failed to stream");
        }
        const responseData = await resData.json();
        responseId.current = responseData.response_id
        setConversationId(responseData.conversation_id);
        const rawHtml: string = await marked.parse(responseData.response);
        const tool_calls = responseData.metadata.tool_calls || [];
        const extra_data = responseData.metadata.extra_data;

        if (responseData.is_chart && responseData.response) {
          try {
            const chartData = JSON.parse(responseData.response);
            setMessages((preVal) => {
              return [
                ...preVal,
                {
                  sender: PlayGroundEnum.AGENT,
                  agentData: {
                    response: "",
                    rawResponse: responseData.response,
                    conversation_id: responseData.conversation_id,
                    chartData: chartData,
                    metadata: { tool_calls: tool_calls, extra_data: extra_data },
                  },
                },
              ];
            });
          } catch (chartError) {
            console.error("Failed to parse chart data:", chartError);
          }
        } else {
          const hasChart = await hasChartDataApi(responseData.response);
          const maybeChart = hasChart ? tryParseChartFromRaw(responseData.response) : null;
          // Update chartability state for non-streaming responses
          setIsAgentChartable(!!(maybeChart || hasChart));
          setMessages((preVal) => {
            return [
              ...preVal,
              {
                sender: PlayGroundEnum.AGENT,
                agentData: {
                  response: maybeChart ? "" : rawHtml,
                  rawResponse: responseData.response,
                  ...(maybeChart
                    ? { chartData: maybeChart }
                    : { hasChart: hasChart }),
                  metadata: { tool_calls: tool_calls, extra_data: extra_data },
                },
              },
            ];
          });
          if (userInputText) {
            checkAndShowForm(userInputText, messages.length);
          }
        }
      }
    } catch (err) {
      console.error("Streaming failed:", err);
    } finally {
      setBotTyping(false);
    }
    setUserInput(""); // Hide Welcome messages
  };

  const clearChat = () => {

    isCancelledStream.current = true;
    setMessages([]);
    setUserInput("");
    setBotTyping(false);
    setShowInitialMessage(true);
    setShowQuestions(true);
  };

  // const handleClick = (option: string) => {
  //   console.log(`Selected option: ${option}`);
  //   // For chips at the bottom
  //   if (option) {
  //     setUserInput(option);
  //     inputRef.current?.focus();
  //   }
  // };

  const updateBubbleColor = (bubbleColor: string) => {
    // setBubbleColor(bubbleColor);
    setAgentTheme((prev) => ({ ...prev, chatBubbleButtonColor: bubbleColor }));
    if (!agents || !agents.id) return;
    setAgents((prev: Agent | undefined) => {
      if (prev) {
        return { ...prev, agent_metadata: { ...prev.agent_metadata, agent_theme: agentTheme } };
      }
      return prev;
    });
  };
  const updateIncomingTextColor = (incomingTextColor: string) => {
    // setIncomingTextColor(incomingTextColor);
    setAgentTheme((prev) => ({ ...prev, incomingChatTextColor: incomingTextColor }));
    if (!agents || !agents.id) return;
    setAgents((prev: Agent | undefined) => {
      if (prev) {
        return { ...prev, agent_metadata: { ...prev.agent_metadata, agent_theme: agentTheme } };
      }
      return prev;
    });
  };
  const updateOutgoingTextColor = (outgoingTextColor: string) => {
    // setOutgoingTextColor(outgoingTextColor);
    setAgentTheme((prev) => ({ ...prev, outgoingChatTextColor: outgoingTextColor }));
    if (!agents || !agents.id) return;
    setAgents((prev: Agent | undefined) => {
      if (prev) {
        return { ...prev, agent_metadata: { ...prev.agent_metadata, agent_theme: agentTheme } };
      }
      return prev;
    });
  };
  const updateTitleColor = (titleColor: string) => {
    // setTitleColor(titleColor);
    setAgentTheme((prev) => ({ ...prev, titleColor: titleColor }));
    if (!agents || !agents.id) return;
    setAgents((prev: Agent | undefined) => {
      if (prev) {
        return { ...prev, agent_metadata: { ...prev.agent_metadata, agent_theme: agentTheme } };
      }
      return prev;
    });
  };
  const updateChatWindowBg = (color: string, mode: string, angle: number) => {
    // setChatWindowColor(color);
    setAgentTheme((prev) => ({ ...prev, backgroundColor: color, mode: mode, angle: angle }));
    if (!agents || !agents.id) return;
    setAgents((prev: Agent | undefined) => {
      if (prev) {
        return { ...prev, agent_metadata: { ...prev.agent_metadata, agent_theme: agentTheme } };
      }
      return prev;
    });
  };

  const saveThemeChanges = async () => {
    if (!agents || !agents.id) return;
    try {
      dispatch(StartLoading());

      const data = await BaseInstance.put(`${AGENT}/${agents.id}`, agents).then(
        (res) => res?.data
      );
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  }



  // Generate chart for a given message by invoking the shortcut API (non-streaming)
  const generateChartForMessage = async (messageIndex: number) => {
    try {
      setChartLoadingByMessage((prev) => ({ ...prev, [messageIndex]: true }));
      const msg = messages[messageIndex];
      if (!msg || msg.sender !== PlayGroundEnum.AGENT) return;

      const raw = (msg as any).agentData?.rawResponse as string | undefined;
      const html = (msg as any).agentData?.response as string | undefined;
      const plainText = raw ?? striptags(html || "");
      const contentForChart = (plainText || "").trim();
      if (contentForChart.length < 10) {
        dispatch(ShowError("Content too short to generate chart"));
        return;
      }

      const data: any = {
        action: "chart_format",
        original_content: contentForChart,
        conversation_id: conversationId ? conversationId : "",
      };

      const res = await fetch(`${AGENT}/${agentId}/post-response-shortcut?stream=false`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${GetSession()}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
        mode: "cors",
        credentials: "same-origin",
      });

      if (!res.ok) {
        try {
          const err = await res.json();
          dispatch(ShowError(err?.detail || "Failed to generate chart"));
        } catch {
          dispatch(ShowError("Failed to generate chart"));
        }
        return;
      }
      const responseData = await res.json();
      const chartJson = responseData?.response;
      if (!chartJson) {
        dispatch(ShowError("No chart data returned"));
        return;
      }
      try {
        const chartData = JSON.parse(chartJson);
        setMessages((prev) => {
          const copy = [...prev];
          const target = copy[messageIndex];
          if (!target || target.sender !== PlayGroundEnum.AGENT) return prev;
          (target as any).agentData = {
            ...((target as any).agentData || {}),
            rawResponse: chartJson,
            chartData,
            // Keep the existing response text instead of clearing it
            response: (target as any).agentData?.response || "",
          } as any;
          copy[messageIndex] = target;
          return copy;
        });
        setChartVisibilityByMessage((prev) => ({ ...prev, [messageIndex]: true }));
      } catch (e) {
        console.error("Failed to parse chart data from shortcut:", e);
        dispatch(ShowError("Invalid chart data returned"));
      }
    } catch (e) {
      console.error("Generate chart failed:", e);
      dispatch(ShowError("Failed to generate chart"));
    } finally {
      setChartLoadingByMessage((prev) => ({ ...prev, [messageIndex]: false }));
    }
  };

  const toggleChartVisibility = (messageId: number) => {
    const enabling = !chartVisibilityByMessage[messageId];

    // If enabling and no chart present yet, generate it via shortcut API and stop here
    if (enabling) {
      const msg = messages[messageId];
      const hasChartDataObj = !!(msg as any)?.agentData?.chartData;
      if (!hasChartDataObj && isAgentChartable) {
        generateChartForMessage(messageId);
        return;
      }
    }

    setChartVisibilityByMessage((prev) => ({
      ...prev,
      [messageId]: !prev[messageId],
    }));

    // If enabling chart view and chartData is not yet parsed but raw JSON is present, try to parse from raw
    setMessages((prev) => {
      const copy = [...prev];
      const msg = copy[messageId];
      if (!msg || msg.sender !== PlayGroundEnum.AGENT) return prev;
      const enablingLocal = !chartVisibilityByMessage[messageId];
      const hasChartDataObj = !!(msg as any).agentData?.chartData;
      const raw = (msg as any).agentData?.rawResponse as string | undefined;
      if (enablingLocal && !hasChartDataObj && raw) {
        const parsed = tryParseChartFromRaw(raw);
        if (parsed) {
          (msg as any).agentData = {
            ...((msg as any).agentData || {}),
            chartData: parsed,
            response: "",
          } as any;
        }
      }
      copy[messageId] = msg;
      return copy;
    });
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [showHistory, setShowHistory] = React.useState(false);
  const handleViewRecentChats = async () => {
    try {
      dispatch(StartLoading());

      const res = await BaseInstance.get(`/conversations`, {
        params: {
          agent_id: agentId,
          skip: 0,     // page 1 → skip = (1 - 1) * 10
          limit: 10,
        },
      });

      const items = await Promise.all<ChatHistoryItem>(
        res.data.map(async (item: any) => {
          const msgRes = await BaseInstance.get(`/conversations/${item.id}`);
          const msgs = Array.isArray(msgRes.data.messages) ? msgRes.data.messages : [];

          return {
            id: item.id,
            agent_id: item.agent_id,
            user_id: item.user_id,
            conversation_id: item.id,
            agent_name: item.title || "Chat",
            message_count: msgs.length,
            first_message_preview: (msgs[0]?.content || "").slice(0, 80),
            last_message_preview: (msgs[msgs.length - 1]?.content || "").slice(0, 80),
            created_at: item.created_at,
            organization_id: item.organization_id || null,
          };
        })
      );

      items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

      setHistoryData({
        items: items as ChatHistoryItem[],
        pagination: {
          total: items.length || 1,
          page: 1,
          perPage: 10,
        },
      });



      setShowHistory(true);
    } catch (err) {
      dispatch(ShowError("Failed to load recent chats"));
    } finally {
      dispatch(StopLoading());
    }

    handleClose();
  };


  const handlePageChange = async (page: number) => {
    try {
      dispatch(StartLoading());

      const res = await BaseInstance.get(`/conversations`, {
        params: {
          agent_id: agentId,
          skip: (page - 1) * 10,
          limit: 10,
        },
      });

      const items = await Promise.all<ChatHistoryItem>(
        res.data.map(async (item: any) => {
          const msgRes = await BaseInstance.get(`/conversations/${item.id}`);
          const msgs = Array.isArray(msgRes.data.messages) ? msgRes.data.messages : [];

          return {
            id: item.id,
            agent_id: item.agent_id,
            user_id: item.user_id,
            conversation_id: item.id,
            agent_name: item.title || "Chat",
            message_count: msgs.length,
            first_message_preview: (msgs[0]?.content || "").slice(0, 80),
            last_message_preview: (msgs[msgs.length - 1]?.content || "").slice(0, 80),
            created_at: item.created_at,
            organization_id: item.organization_id || null,
          };
        })
      );

      items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

      setHistoryData({
        items: items as ChatHistoryItem[],
        pagination: {
          total: items.length || historyData.pagination.total || 1,
          page,
          perPage: 10,
        },
      });


    } catch (err) {
      dispatch(ShowError("Failed to load chat history"));
    } finally {
      dispatch(StopLoading());
    }
  };


  const handleChatSelect = async (chatHistoryId: string) => {
    try {
        dispatch(StartLoading());
        const res = await BaseInstance.get(`/conversations/${chatHistoryId}`);

        clearChat();

        // FIX: Hide prompts & welcome message for history view
        setShowQuestions(false);
        setShowInitialMessage(false);

        setShowHistory(false);

        const oldMessages = await Promise.all(
          res.data.messages.map(async (msg: any) => {
            const isUser = msg.sender === "user" || msg.sender === "human" || msg.role === "user";
            return {
              sender: isUser ? PlayGroundEnum.USER : PlayGroundEnum.AGENT,
              ...(isUser
                ? { userData: { input: msg.content } }
                : { agentData: { response: await marked.parse(msg.content || "") } }),
            };
          })
        );

        setMessages(oldMessages);
    } catch (err) {
        dispatch(ShowError("Failed to load chat"));
    } finally {
        dispatch(StopLoading());
    }
  };



  const handleStartNewChat = () => {
    setShowHistory(false);
    clearChat();
    handleClose();
  };

  const handleEndChat = () => {
    clearChat();
    handleClose();
  };
  const handleBackToChat = () => {
    setShowHistory(false);
  };

  const [showSettings, setShowSettings] = useState(false);

  // Smooth Scrolling to Bottom on New Message

  return (
    <Box
      sx={{
        height: "calc(100vh - 81px)",
        display: "flex",
        position: "relative",
        transition: "all 0.3s ease",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          justifyContent: "left",
          position: "absolute",
          left: "26px",
          top: "9px",
          zIndex: 1,
        }}
      >
        <Button
          variant="text"
          startIcon={<KeyboardBackspaceIcon />}
          onClick={() => navigate(-1)}
          sx={{
            textTransform: "capitalize",
          }}
        >
          Back
        </Button>
        <Button
          size="small"
          variant="text"
          startIcon={<SettingsOutlinedIcon />}
          sx={{ textTransform: "capitalize" }}
          onClick={() => setShowSettings(true)}
        >
          Chat Interface Settings
        </Button>
      </Box>

      <Box
        sx={{
          width: "40%",
          background: "#fff",
          p: "32px",
          borderRight: "1px solid #E3E3E3",
          transition: "all 0.3s ease",
          //position: "relative"
          position: "absolute",
          top: 0,
          bottom: 0,
          left: showSettings ? 0 : "-40%",
        }}
      >
        <IconButton
          onClick={() => setShowSettings(false)}
          sx={{ position: "absolute", top: "3px", right: "21px" }}
        >
          <CloseIcon />
        </IconButton>
        <ChatInterfaceSettings
          chatIcon={chatIcon}
          setChatIcon={setChatIcon}
          profileImage={profileImage}
          setProfileImage={setProfileImage}
          updateBubbleColor={updateBubbleColor}
          updateIncomingTextColor={updateIncomingTextColor}
          updateOutgoingTextColor={updateOutgoingTextColor}
          updateTitleColor={updateTitleColor}
          updateChatWindowBg={updateChatWindowBg}
          agentTheme={agentTheme}
          saveThemeChanges={saveThemeChanges}
        />
      </Box>

      <Box
        sx={{
          width: showSettings ? "60%" : "100%",
          marginLeft: showSettings ? "40%" : "0",
          transition: "all 0.3s ease",
          background: "radial-gradient(circle, #f3f3f3 25%, transparent 26%)",
          backgroundSize: "1em 1em",
          backgroundColor: "#ffffff",
          opacity: "1",
          p: 4,
        }}
      >
        <Box
          sx={{
            maxWidth: "660px",
            height: "94%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
              borderRadius: "30px",
              background: agentTheme.backgroundColor,
              overflow: "hidden",
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
            }}
          >
            {showHistory ? (
                <RecentChatsByUser
                    onBack={handleBackToChat}
                    historyData={historyData}
                    onPageChange={handlePageChange}
                    clearChat={clearChat}
                    onChatSelect={handleChatSelect}
                />
            ) : (
              <Box
                sx={{
                  height: "100%",
                }}
              >
                <Box
                  position="sticky"
                  sx={{
                    // backgroundColor: "#fff",
                    borderBottom: "1px solid #f9f7f7",
                    px: 4,
                    py: 1.5,
                    //height: "45px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    // boxShadow: "0 15px 30px 0 rgba(256, 256, 256, 1)",
                    zIndex: 1,
                    top: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={profileImage || LogoIcon}
                        alt="Company Logo"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        flexGrow: 1,
                        textTransform: "capitalize",
                        color: agentTheme.titleColor,
                      }}
                    >
                      {agents?.name || "Chat"}
                    </Typography>
                  </Box>
                  {/* <IconButton onClick={clearChat} title="Clear chat">
                <CachedIcon />
              </IconButton> */}
                  <Box>
                    <IconButton
                      id="demo-positioned-button"
                      aria-controls={open ? "demo-positioned-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    >
                      <MoreHorizIcon />
                    </IconButton>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      PaperProps={{
                        elevation: 0, // Disable default MUI shadow
                        sx: {
                          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                          borderRadius: 2,
                        },
                      }}
                    >
                      <MenuItem onClick={e => {
                        e.preventDefault();
                        handleStartNewChat();
                      }}>
                        <ListItemIcon>
                          <NewChatIcon />
                        </ListItemIcon>
                        <ListItemText>Start a new chat</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={e => {
                        e.preventDefault();
                        handleEndChat();
                      }}>
                        <ListItemIcon>
                          <EndChatIcon />
                        </ListItemIcon>
                        <ListItemText>End chat</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={handleViewRecentChats}>
                        <ListItemIcon>
                          <RecentChatIcon />
                        </ListItemIcon>
                        <ListItemText>View recent chats</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>
                {/* Chat Messages */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    height: "calc(100% - 160px)",
                    alignItems: "center",
                    pb: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "100%",
                      overflow: "auto",
                      p: 4,
                      position: "relative",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {},
                      "&::-webkit-scrollbar-track": {},
                    }}
                  >
                    {/* Main Text */}
                    {showInitialMessage && (
                      <>
                        <PlayGroundInitialMessage
                          message={intialMessage}
                          incomingTextColor={agentTheme.incomingChatTextColor}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            left: 0,
                            right: 0,
                            gap: 1,
                          }}
                        >
                          <img
                            src={LogoIcon}
                            alt="Company Logo"
                            style={{
                              width: "24px",
                              height: "auto",
                              objectFit: "cover",
                            }}
                          />
                          <Typography variant="body2" sx={{ color: agentTheme.incomingChatTextColor, }}>Powered by ZeaiQ</Typography>
                        </Box>
                      </>
                    )}

                    {messages.map((msg, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "flex-start",
                          mb: 3,
                        }}
                      >
                        <Box sx={{ width: "100%" }}>
                          {/* Tool chips visible for all messages */}
                          {msg?.agentData?.metadata?.tool_calls &&
                            msg?.agentData?.metadata?.tool_calls?.length >
                            0 && (
                              <AgentPlayGroundTools
                                tools={msg?.agentData.metadata.tool_calls || []}
                              />
                            )}

                          {/* Bot Message */}
                          {msg.sender === PlayGroundEnum.AGENT ? (
                            <Box sx={{ display: "flex", width: "100%" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  mr: 2,
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  //overflow: "hidden",
                                }}
                              >
                                <img
                                  src={profileImage || LogoIcon}
                                  alt="Company Logo"
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    objectFit: "cover",
                                  }}
                                />
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >

                                {/* Main Text */}
                                {agents?.agent_metadata?.markdown ? (
                                  <Typography
                                    key={index}
                                    variant="body2"
                                    component="div"
                                    sx={{
                                      color: agentTheme.incomingChatTextColor,
                                      whiteSpace: "normal",
                                      "& table": {
                                        borderCollapse: "collapse",
                                        width: "100%",
                                        margin: "8px 0",
                                      },
                                      "& th, & td": {
                                        border: "1px solid #bdbdbd",
                                        padding: "6px 10px",
                                      },
                                      "& th": {
                                        background: "#f5f5f5",
                                        fontWeight: 600,
                                      },
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: msg?.agentData?.response || "...",
                                    }}
                                  />
                                ) : (
                                  //Markdown disabled — render plain text only
                                  <Typography
                                    variant="body2"
                                    component="div"
                                    sx={{
                                      color: agentTheme.incomingChatTextColor,
                                      whiteSpace: "pre-wrap",
                                      // overflowWrap: "break-word",
                                    }}
                                  >
                                    {decodeHTMLEntities(striptags(msg?.agentData?.response || "..."))}
                                  </Typography>
                                )}

                                {/* AI-driven Contact Form */}
                                {showContactFormForMessageIndex === index && (
                                  <ContactForm agentTheme={agentTheme}
                                    conversationId={conversationId}
                                   onClose={() => setShowContactFormForMessageIndex(null)} />
                                )}

                                {/* Audio Response */}
                                {msg?.agentData?.audioResponse && (
                                  <Box sx={{ mt: 1, mb: 1 }}>
                                    <VoiceRecorder
                                      onRecordingComplete={() => { }}
                                      disabled={true}
                                      size="small"
                                      showPlayback={true}
                                      showMicIcon={false}
                                      audioUrl={(() => {
                                        try {
                                          // Use audio format from metadata, fallback to mp3
                                          const audioFormat = msg?.agentData?.metadata?.audio_format || 'mp3';
                                          const audioBlob = new Blob([Uint8Array.from(atob(msg.agentData.audioResponse), c => c.charCodeAt(0))], { type: `audio/${audioFormat}` });
                                          return URL.createObjectURL(audioBlob);
                                        } catch (error) {
                                          console.error('Error creating audio URL:', error);
                                          return undefined;
                                        }
                                      })()}
                                    />
                                  </Box>
                                )}
                                {/* Chart rendering */}
                                {chartLoadingByMessage[index] && (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                                    <CircularProgress size={18} />
                                    Generating chart...
                                  </Box>
                                )}
                                {msg?.agentData?.chartData && chartVisibilityByMessage[index] && (
                                  <PlotlyChart
                                    data={msg.agentData.chartData.data || []}
                                    layout={msg.agentData.chartData.layout || {}}
                                    config={msg.agentData.chartData.config || { displayModeBar: false }}
                                  />
                                )}
                                {/* propmts and short cuts */}
                                <AgentPrompts
                                  agentShortuts={agentShortuts}
                                  messageId={index}
                                  sendMessageShortcuts={sendMessageShortcuts}
                                  incomingTextColor={agentTheme.incomingChatTextColor}
                                  hasChart={!!msg?.agentData?.chartData || !!(msg as any)?.agentData?.hasChart}
                                  isChartVisible={!!chartVisibilityByMessage[index]}
                                  chartLoading={!!chartLoadingByMessage[index]}
                                  onToggleChart={toggleChartVisibility}
                                  isChartable={msg?.agentData?.isChartable}
                                  messages={messages}
                                  setMessages={setMessages}
                                  agentId={agentId}
                                  responseId={responseId.current}
                                  conversationId={conversationId}
                                />
                                {/* {msg?.agentData?.response || '...'}
                          </Typography> */}

                                {/* References */}
                                {msg.agentData?.metadata?.extra_data && (
                                  <AgentPlaygroundReferences
                                    data={msg.agentData?.metadata?.extra_data}
                                    incomingTextColor={agentTheme.incomingChatTextColor}
                                    setShowCitations={setShowCitations}
                                  />
                                )}
                              </Box>
                            </Box>
                          ) : (
                            // User Message
                            <Box sx={{ display: "flex" }}>
                              <Avatar
                                variant="rounded"
                                sx={{
                                  width: 24,
                                  height: 24,
                                  borderRadius: "50%",
                                  bgcolor: variables.blackColor,
                                  mr: 2,
                                  p: "3px",
                                }}
                              >
                                <LineMdAccount />
                              </Avatar>
                              <Typography
                                variant="body2"
                                sx={{
                                  lineHeight: "24px",
                                  whiteSpace: "pre-wrap",
                                  color: agentTheme.outgoingChatTextColor,
                                }}
                                dangerouslySetInnerHTML={{ __html: msg?.userData?.input || "" }}
                              />
                              {/* {msg?.userData?.input} */}
                              {/* </Typography> */}
                            </Box>
                          )}
                        </Box>
                        <div ref={endOfMessagesRef} />
                      </Box>
                    ))}
                    {botTyping && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "flex-start",
                          mb: 3,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            mr: 2,
                            height: "24px",
                          }}
                        >
                          <img
                            src={LogoIcon}
                            alt="Company Logo"
                            style={{ width: 24, height: "auto" }}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            height: 24,
                          }}
                        >
                          <TypingIndicator />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Input Field */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "flex-start",
                    p: 2,
                    bgcolor: "rgba(255, 255, 255, 0.2)",
                    width: "100%",
                    position: "sticky",
                    bottom: 0,
                    borderTop: "1px solid rgba(24, 24, 27, .1)",
                    flexDirection: "column",
                  }}
                >
                  {/* default questions */}
                  {showQuestions && agentId && (
                    <AgentQuestions
                      sendMessageQuestions={sendMessageQuestions}
                      agentId={agentId}
                    />
                  )}

                  <Box
                    sx={{
                      border: "1px solid rgba(24, 24, 27, .1)",
                      boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                      borderRadius: "20px",
                      width: "100%",
                      position: "relative",
                      padding: "12px 16px",
                      background: "#fff",
                    }}
                  >
                    <TextField
                      fullWidth
                      multiline
                      variant="outlined"
                      size="small"
                      maxRows={4}
                      inputProps={{ maxLength: 5000 }}
                      placeholder="Ask anything..."
                      value={userInput}
                      onChange={(e) => setUserInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          sendMessage();
                        }
                      }}
                      inputRef={inputRef}
                      disabled={botTyping}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: "14px",
                          maxHeight: "120px", // Add maximum height
                          overflowY: "auto", // Enable vertical scrolling
                          pr: "40px", // Space for the send button
                          "&::-webkit-scrollbar": {
                            width: "6px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                            borderRadius: "3px",
                          },
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: "10px",
                        right: "10px",
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      {agents?.agent_metadata?.voice_enabled && agents?.has_voice_subscription &&(
                        <VoiceRecorder
                          onRecordingComplete={sendVoiceMessage}
                          disabled={botTyping}
                          size="small"
                        />
                      )}
                      <Button
                        onClick={sendMessage}
                        disabled={botTyping || !userInput}
                        sx={{
                          width: 40,
                          height: 40,
                          backgroundColor: agentTheme.chatBubbleButtonColor || variables.blackColor,
                          color: variables.whiteColor,
                          minWidth: 0,
                          borderRadius: "50%",
                          "&.Mui-disabled": {
                            color: variables.whiteColor,
                            opacity: 0.5,
                          },
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 14L21 3m0 0l-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1z"
                          />
                        </svg>
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              width: "55px",
              height: "55px",
              borderRadius: "50%",
              backgroundColor: agentTheme.chatBubbleButtonColor || variables.blackColor,
              marginLeft: "auto",
              marginTop: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={chatIcon || ChatIcon}
              alt="Chat Icon"
              style={{ width: 30, height: "auto" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AgentPlayground;
